import { CSSProperties } from 'react';
import styled, { css, keyframes } from 'styled-components';

type ModalOverlayProps = {
  alignment?: 'left' | 'center' | 'right';
};

export const ModalOverlay = styled.div<ModalOverlayProps>`
  ${({ alignment = 'center' }) => css`
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.4);
    display: flex;
    justify-content: ${alignment};
    align-items: center;
    z-index: 10;
  `}
`;

type ModalContentProps = {
  height?: CSSProperties['height'];
  width?: CSSProperties['width'];
  alignment?: 'left' | 'center' | 'right';
  backgroundColor?: CSSProperties['backgroundColor'];

};

export const ModalContent = styled.div<ModalContentProps>`
  ${({ height = '80vh', width = '60vw', alignment = 'center', backgroundColor = '#fff' }) => css`
    position: relative;
    background-color: ${backgroundColor};
    border-radius: 5px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    display: flex;
    flex-direction: column;
    ${margins[alignment]}
    height: ${height};
    width: ${width};
    -webkit-animation-name: ${animations[alignment]};
    -webkit-animation-duration: 0.4s;
    animation-name: ${animations[alignment]};
    animation-duration: 0.4s;
  `}
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 20px;
`;

export const ModalCloseButton = styled.button`
  display: flex;
  position: absolute;
  background-color: transparent;
  border: none;
  cursor: pointer;
  top: 0;
  right: 0;
  padding: 0;
  border-radius: 6px;
  margin: 5px;
  &:hover {
    background: #eeeeee;
  }
  &:active {
    background: #d9d9d9;
  }
`;

export const ModalTitle = styled.h3`
  margin-block-start: 0.5rem;
  margin-block-end: 0.5rem;
  font-size: 28px;
`;

export const ModalBody = styled.div`
  flex-grow: 1;
`;

const animations = {
  left: keyframes`
    from {
      left: -300px;
      opacity: 0;
    }
    to { 
      left: 0;
      opacity: 1;
    }
  `,
  center: keyframes`
    from {
      top: -300px;
      opacity: 0;
    }
    to { 
      top: 0;
      opacity: 1;
    }
  `,
  right: keyframes`
    from {
      right: -300px;
      opacity: 0;
    }
    to { 
      right: 15px;
      opacity: 1;
    }
  `,
};

const margins = {
  right: css`
    right: 15px;
  `,
};
